import { GetHistoryResponse, PlayerGroup } from '@img-arena/consoles-api-golf-pricing'
import type { TeamRound } from '@/types/dde/teamRound.types'

import type { OddsDataRow } from './OddsDataContent/oddsData.dde.table'
import {
  convertTeamRoundToOddsDataRow,
  getOddsDataThreeBallTableRows,
  getOddsDataWinnerTableRows
} from './OddsDataContent/oddsData.dde.table'
import { MarketTypes } from './constants'

interface GetTableRowsParams {
  oddsHistory: GetHistoryResponse['oddsEntries'] | null
  marketType: string | null | undefined
  filteredTeamRoundActions: TeamRound[]
  playerGroups: PlayerGroup[] | null | undefined
  selectedPlayerIds: number[]
  rawDataMap: Map<TeamRound, unknown>
}

export const getOddsDataTableRows = ({
  oddsHistory,
  marketType,
  filteredTeamRoundActions,
  playerGroups,
  selectedPlayerIds,
  rawDataMap
}: GetTableRowsParams): OddsDataRow[] => {
  const oddsRows =
    !oddsHistory || oddsHistory.length === 0
      ? []
      : marketType === MarketTypes.WINNER
        ? getOddsDataWinnerTableRows(oddsHistory)
        : getOddsDataThreeBallTableRows(oddsHistory)

  const teamRoundRows = filteredTeamRoundActions.map((action) => {
    let playerName = action.player?.displayName || ''
    const actionPlayerId = action.playerId

    if (playerGroups && selectedPlayerIds.includes(actionPlayerId)) {
      const allPlayers = playerGroups.flatMap((group) => group.players)
      const matchingPlayer = allPlayers.find((p) => p.playerId === actionPlayerId)
      if (matchingPlayer) {
        playerName = matchingPlayer.playerFullName
      }
    }

    const rawData = rawDataMap.get(action)

    const row = convertTeamRoundToOddsDataRow(
      action as TeamRound & { timestamp?: string },
      playerName
    )
    if (rawData) {
      row.rawActionData = rawData
    }
    return row
  })

  const allRows = [...oddsRows, ...teamRoundRows].sort((a, b) => {
    const timeA = new Date(a.time).getTime()
    const timeB = new Date(b.time).getTime()
    return timeB - timeA
  })

  return allRows
}
